import { PropsWithChildren } from 'react';

export enum Feature {
  BRIDGE = 'bridge',
  GOVERNANCE = 'governance',
  OLD_GOVERNANCE = 'old governance',
  REFERRAL = 'referral',
}

export type PropsWithClassName<T = unknown> = T & { className?: string };
export type PropsWithClassNameAndChildren<T = unknown> = PropsWithChildren<
  PropsWithClassName<T>
>;
